import { dynamicWrapper, createRoute } from '@/utils/core';
import OrgTree from './components/OrgTree';
import OrgSelectModal from './components/OrgSelectModal';

const routesConfig = app => ({
  path: '/org',
  title: window.language['menu.sysConfig.org'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
export {
  OrgTree,
  OrgSelectModal
}



// WEBPACK FOOTER //
// ./src/routes/System/Org/index.js